
/** Tracks the current status of a paged result set. */
export class PagerSettings {

	public previousPageNumber: number = 0;
	public nextPageNumber: number = 0;
	public pageSize: number = 0;
	public pageIndex: number = 0;
	public pageNumber: number = 1;
	public totalResults: number = 0;
	public totalPages: number = 0;
	public enableNextButton: boolean = false;
	public enablePrevButton: boolean = false;
	public earliestYear?: number;
	public latestYear?: number;

	constructor(init?: Partial<PagerSettings>) {
		Object.assign(this, init);
	}

}
